export enum StoreType {
  MAP = 'Map',
  INDEXED_DB = 'IndexedDB'
}

export type CacheData = ArrayBuffer | string | number[];

export interface CacheConfig {
  id: string;
  maxBytes: number;
  type: StoreType;
}

export interface StoreEvents {
  ondelete: (event: { key: string }) => void;
  onset: (event: { key: string }) => void;
}

export interface CacheStore<T> {
  config: CacheConfig;

  initialize: () => Promise<void>;

  /**
   * Get an item for the given key. This moves that key|value to the end, as it's recently used.
   * @param key - keys to lookup value.
   * @returns value at key
   */
  get: (key: string) => Promise<T | undefined>;

  /**
   * Set an item for the given key. This moves that key|value to the end, as it's recently used.
   * @param key - key for insert
   * @param value - value to insert at key
   */
  set: (key: string, value: T) => Promise<boolean>;

  delete: (key: string) => Promise<boolean>;

  /**
   * true if the cache has a key.
   * @param key - key to check
   * @returns - true if exits
   */
  has: (key: string) => boolean;

  /**
   * Get the keys for objects in the cache.
   * @returns list of keys
   */
  keys: () => IterableIterator<string>;

  /**
   * Return the size of bytes for the cached payload.
   */
  getPayloadSize: (key: string) => Promise<number>;

  /**
   * Return the timestamp for which the object was cached.
   */
  getTimestamp: (key: string) => Promise<number>;

  /**
   * Cleanup resources.
   */
  clear: () => void;
}
